<template lang="pug">
  v-slide-y-transition(mode="out-in")
    v-container(fluid v-if="!isLoading()")
      v-form(ref="saleCategoryForm", @submit.prevent="handleSubmit")
        v-card(class="mb2")
          v-card-title
            h3.headeline Datos de la categoría

          v-card-text
            v-text-field(:label="$t('Nombre')", v-model="saleCategory.name", :rules="validation.required", required)
            v-textarea(:label="$t('Descripción')", v-model="saleCategory.description", required, :rows="2", auto-grow, hint="Se utilizará para posicionamiento y redes sociales")

          v-card-actions
            v-btn(color="red" dark @click="$router.push('/sales')") Cancelar
            v-spacer
            v-btn(color="primary", type="submit") Guardar

    v-container(fluid fill-height v-else)
      v-layout(flex align-center justify-center)
        v-progress-circular(indeterminate, color="primary", :size="128", :width="2")
</template>

<style scoped>
.image {
  height: 200px;
  margin: 10px 0;
}
</style>

<script>
import validation from '@/utils/validation';

const emptySale = {
  id: null,
  name: '',
  description: null,
};

export default {
  data() {
    return {
      saleCategory: {},
      loading: {
        saleCategory: false,
      },
      validation,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    isLoading() {
      return this.loading.saleCategory;
    },
    fetchData() {
      this.loading.saleCategory = true;

      if (this.$route.params.id) {
        api.get(`/sales_categories/${this.$route.params.id}`).then((res) => {
          this.saleCategory = res.data;
        }).catch(this.handleError)
          .finally(() => { this.loading.saleCategory = false; });
      } else {
        this.saleCategory = Object.assign({}, emptySale);
        this.loading.saleCategory = false;
      }
    },
    handleSubmit() {
      if (this.$refs.saleCategoryForm.validate()) {
        this.loading.saving = true;
        if (this.saleCategory.id === null) {
          api.post('/sales_categories', this.saleCategory).then(() => {
            this.$router.push('/sales');
          }).catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        } else {
          api.put(`/sales_categories/${this.saleCategory.id}`, this.saleCategory).then(() => {
            this.$router.push('/sales');
          }).catch(this.handleError)
            .finally(() => {
              this.loading.saving = false;
            });
        }
      }
    },
    handleError(err) {
        // eslint-disable-next-line no-console
      console.error(err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Sales/SaleCategoryForm.vue